__webpack_require__.p = "/reports-amount-of-data/referrals/";